import React from 'react';
import { PhoneCall } from 'lucide-react';
import { useBrowserCall } from '../contexts/BrowserCallContext';

// The "Call via Gain Rhino VoIP" icon rendered next to a phone number.
// Renders nothing unless the server says this user may place browser
// calls (assigned + verified line, add-on, quota, Twilio configured), so
// the existing tel: link is never disturbed for everyone else.
//
// `guard(proceed)` lets the host page run its lead-claim prompt first
// (same first-come-first-served flow the tel: links use).
export default function BrowserCallButton({ lead, phone, guard, disabled = false, className = '', size = 15, label }) {
  const { canCall, busy, startCall } = useBrowserCall();
  if (!canCall || !phone || !lead?._id) return null;
  const isDnc = lead.status === 'do_not_call';
  const off = disabled || isDnc || busy;
  const title = isDnc ? 'On the do-not-call list'
    : busy ? 'Finish the current call first'
    : disabled ? 'Locked'
    : 'Call via Gain Rhino VoIP';

  const go = () => startCall({ lead, phone });
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (off) return;
    if (typeof guard === 'function') guard(go);
    else go();
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={off}
      title={title}
      aria-label={title}
      className={`inline-flex items-center justify-center gap-1 rounded-md align-middle min-w-[28px] min-h-[28px] px-1 ${
        off ? 'text-gray-300 cursor-not-allowed' : 'text-teal-700 bg-teal-50 hover:bg-teal-100'
      } ${className}`}
    >
      <PhoneCall size={size} />
      {label && <span className="text-xs font-medium">{label}</span>}
    </button>
  );
}
